<template>
  <l-table
    ref="LTable"
    :module-name="MODULE_NAME"
    :table-columns="tableColumns"
  >
    <template #create-button>
      <b-button
        v-if="$can('manage', 'DirectionSectorCode')"
        v-b-toggle.sidebar-create-direction-sector-code
        variant="primary"
        @click="create"
      >
        {{ $t('Create') }}
      </b-button>
    </template>

    <template #create-body>
      <create @refetchData="refetchData" />
    </template>

    <template #cell(direction)="{ data }">
      {{ directionLabel(data.value) }}
    </template>

    <template #cell(category_subject)="{ data }">
      {{ categorySubjectLabel(data.value) }}
    </template>

    <template #cell(actions)="{ data }">
      <div class="text-nowrap">
        <feather-icon
          v-if="$can('update', 'DirectionSectorCode')"
          v-b-toggle.sidebar-create-direction-sector-code
          icon="EditIcon"
          class="cursor-pointer"
          size="16"
          @click="update(data.item)"
        />

        <feather-icon
          v-if="$can('delete', 'DirectionSectorCode')"
          :id="`direction-sector-code-${data.item.id}-remove-icon`"
          icon="TrashIcon"
          size="16"
          class="mx-1 cursor-pointer"
          @click="remove(data.item)"
        />
      </div>
    </template>
  </l-table>
</template>

<script>
import {
  BButton, VBToggle,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import directionSectorCodeModule from '@/store/direction-sector-code'
import LTable from '@/views/components/LTable.vue'
import Create from './Create.vue'
import config from './config'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    LTable,
    BButton,
    Create,
  },
  created() {
    this.$store.commit(`${this.MODULE_NAME}/FRESH`)
    this.$store.dispatch(`${this.MODULE_NAME}/fetchDirections`)
    this.$store.dispatch(`${this.MODULE_NAME}/fetchCategorySubjects`)
  },
  methods: {
    create() {
      this.$store.commit(`${this.MODULE_NAME}/FRESH`)
    },
    update(data) {
      this.$store.commit(`${this.MODULE_NAME}/UPDATE`, data)
    },
    remove(data) {
      this.$removeSwal(this, data, `${this.MODULE_NAME}/del`, this.refetchData)
    },
    refetchData() {
      this.$refs.LTable.refetchData()
    },
    directionLabel(id) {
      const direction = this.$store.state[this.MODULE_NAME].directions.find(item => item.id === id)
      return direction ? `${direction.code} - ${this.$langName(direction.name)}` : id
    },
    categorySubjectLabel(id) {
      const categorySubject = this.$store.state[this.MODULE_NAME].categorySubjects.find(item => item.id === id)
      if (!categorySubject) return id
      return `${categorySubject.science_sector_code || categorySubject.code} - ${this.$langName(categorySubject.name)}`
    },
  },
  setup() {
    const MODULE_NAME = 'directionSectorCode'
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, directionSectorCodeModule)

    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })

    return {
      MODULE_NAME,
      ...config(),
    }
  },
}
</script>
